import { useEffect, useState } from "react";

/**
 * Minimal LoadingScreen - optimized for FCP
 * Uses CSS animations instead of framer-motion to reduce initial bundle
 */
export const LoadingScreen = ({ onComplete }: { onComplete: () => void }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Minimal loading screen - 300ms total for fast content visibility
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Small delay for fade out animation
      setTimeout(onComplete, 200);
    }, 100);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-[100] bg-background flex items-center justify-center animate-fade-out"
      style={{ animationDelay: '100ms', animationDuration: '200ms', animationFillMode: 'forwards' }}
    >
      <div className="flex flex-col items-center gap-4">
        <span className="font-display text-2xl md:text-4xl font-bold text-foreground tracking-tight">
          FSHN AI
        </span>
        <div className="w-24 h-0.5 bg-foreground/30 overflow-hidden">
          <div 
            className="h-full bg-foreground/80"
            style={{ 
              animation: 'loading-bar 300ms ease-out forwards',
            }}
          />
        </div>
      </div>
      <style>{`
        @keyframes loading-bar {
          from { width: 0; }
          to { width: 100%; }
        }
        @keyframes fade-out {
          to { opacity: 0; }
        }
        .animate-fade-out {
          animation-name: fade-out;
        }
      `}</style>
    </div>
  );
};
